import React from "react";
import { FaRegCalendarAlt, FaRegClock } from "react-icons/fa";
import LiveClock from "./ui-elements/LiveClock";

const DateAndTimeBar = () => {
  return (
    <div className="flex md:flex-row flex-col w-full text-white  items-center justify-center md:justify-between md:px-36 px-[15px] bg-dark-green">
      <div className="flex  flex-row items-center gap-2">
        <FaRegCalendarAlt className="text-accent-green w-[15px] h-[15px]" />
        <span className="font-poppins">Día </span>
        <span className="font-bold font-poppins">
          {new Date().toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "long",
          })}
          {", "}
          {new Date().toLocaleDateString("es-ES", { year: "numeric" })}
        </span>
      </div>

      <div className="flex flex-row items-center gap-2">
        <FaRegClock className="text-accent-green w-[15px] h-[15px]" />
        <span className="font-poppins">Hora: </span>
        <LiveClock />
      </div>
    </div>
  );
};

export default DateAndTimeBar;
